import { useTheme } from "@mui/material";
import {
	Activity,
	BarChart3,
	Bell,
	Calculator,
	HelpCircle,
	IdCard,
	Settings,
	Shield,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import type { SettingsMenuItemType } from "web_myplann/More/Components/SettingsMenuItem";
import {
	SETTINGS_ACTIVITIES_ICON_BG,
	SETTINGS_ACTIVITIES_ICON_COLOR,
	SETTINGS_CALCULATORS_ICON_BG,
	SETTINGS_CALCULATORS_ICON_COLOR,
	SETTINGS_DOCUMENTS_ICON_BG,
	SETTINGS_DOCUMENTS_ICON_COLOR,
	SETTINGS_FINANCES_ICON_BG,
	SETTINGS_FINANCES_ICON_COLOR,
	SETTINGS_HELP_ICON_BG,
	SETTINGS_HELP_ICON_COLOR,
	SETTINGS_NOTIFICATIONS_ICON_BG,
	SETTINGS_NOTIFICATIONS_ICON_COLOR,
	SETTINGS_SECURITY_ICON_BG,
	SETTINGS_SECURITY_ICON_COLOR,
} from "web_myplann/Utils/constants";
import { device, NavigationTypes } from "web_myplann/Utils/device";

export const useSettingsMenuItems = () => {
	const theme = useTheme();
	const { t } = useResource();
	const navigate = useNavigate();

	const toolItems: SettingsMenuItemType[] = [
		{
			icon: BarChart3,
			label: t(Resources.Settings.Items.FinancialBalance),
			iconBg: SETTINGS_FINANCES_ICON_BG,
			iconColor: SETTINGS_FINANCES_ICON_COLOR,
			onClick: () =>
				navigate(AppRouting.MyPlann.Finances.Intro.path(), {
					state: { from: "profile" },
				}),
		},
		{
			icon: IdCard,
			label: t(Resources.Settings.Items.MyDocuments),
			iconBg: SETTINGS_DOCUMENTS_ICON_BG,
			iconColor: SETTINGS_DOCUMENTS_ICON_COLOR,
			onClick: () => navigate(AppRouting.MyPlann.Profile.Paperwork.path()),
		},
		{
			icon: Activity,
			label: t(Resources.Settings.Items.Activities),
			iconBg: SETTINGS_ACTIVITIES_ICON_BG,
			iconColor: SETTINGS_ACTIVITIES_ICON_COLOR,
			onClick: () => navigate(Routing.ActivitiesList.path()),
		},
		{
			icon: Calculator,
			label: t(Resources.Settings.Items.Calculators),
			iconBg: SETTINGS_CALCULATORS_ICON_BG,
			iconColor: SETTINGS_CALCULATORS_ICON_COLOR,
			onClick: () =>
				device.navigationRequest(NavigationTypes.CalculatorListScreen),
		},
	];

	const settingsItems: SettingsMenuItemType[] = [
		{
			icon: Settings,
			label: t(Resources.Settings.Items.Settings),
			iconBg: theme.palette.grey[100],
			iconColor: theme.palette.grey[600],
		},
		{
			icon: Bell,
			label: t(Resources.Settings.Items.Notifications),
			iconBg: SETTINGS_NOTIFICATIONS_ICON_BG,
			iconColor: SETTINGS_NOTIFICATIONS_ICON_COLOR,
			onClick: () => navigate(AppRouting.MyPlann.Notifications.path()),
		},
		{
			icon: Shield,
			label: t(Resources.Settings.Items.Security),
			iconBg: SETTINGS_SECURITY_ICON_BG,
			iconColor: SETTINGS_SECURITY_ICON_COLOR,
			onClick: () => navigate(AppRouting.MyPlann.Profile.Security.path()),
		},
	];

	const supportItems: SettingsMenuItemType[] = [
		{
			icon: HelpCircle,
			label: t(Resources.Settings.Items.HelpAndSupport),
			iconBg: SETTINGS_HELP_ICON_BG,
			iconColor: SETTINGS_HELP_ICON_COLOR,
		},
	];

	return { toolItems, settingsItems, supportItems };
};
